export default __webpack_public_path__ + "static/media/arrow-right.731887b0.svg";